<div class="video-container" #videoContainer>
  <video #heromov [src]="movieSrc" class="hero-video">
    <source [src]="movieSrc" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>  
</div>
